import React from "react";
import { useLocation } from "react-router-dom";
import Emty from "../../components/Emty/Emty";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
import PostListSection from "../../components/PostListSection/PostListSection";
import UseProjectCommon from "../../hooks/UseProjectCommon";

function Savelist() {
  const category = useLocation().pathname.split("/")[1] as "prjt" | "mtup";
  const [data, ProjectDelete, SearchProject] = UseProjectCommon({
    type: category,
    filter: "&prjt_sts_cd=prjt_sts_tmp&prjt_sort_order=rcrt",
    time: "",
  });
  return (
    <main className="savelist">
      <div className="wrapper">
        <ListSearchSection
          title={`임시저장 ${category === "prjt" ? "프로젝트" : "밋업"}`}
          placeholder={category === "prjt" ? "프로젝트 검색" : "밋업명 검색"}
          isExel={false}
          filter={[]}
          Search={SearchProject}
        />
        {data.length > 0 ? (
          <PostListSection
            type={"save"}
            tags={tag_layout}
            data={data}
            PostRemove={ProjectDelete}
            ProjectPause={undefined}
            category={undefined}
            ChangeProjectSts={undefined}
            __ChangeState={undefined}
            prjtData={undefined}
          />
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default Savelist;

const tag_layout = [
  {
    type: "save-title",
    title: "프로젝트명",
  },
  {
    type: "save-time",
    title: "임시저장기간",
  },
  {
    type: "save-remove",
    title: "삭제하기",
  },
];
